import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import App from './App';
import ErrorBoundary from './components/ErrorBoundary';
import UpdateBanner, { SW_UPDATE_EVENT } from './components/UpdateBanner';
import { I18nProvider } from './i18n';
import * as serviceWorkerRegistration from './serviceWorkerRegistration';

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  <React.StrictMode>
    <I18nProvider>
      <ErrorBoundary>
        <App />
      </ErrorBoundary>
      <UpdateBanner />
    </I18nProvider>
  </React.StrictMode>
);

// Register service worker for PWA functionality
// Change to unregister() if you want to opt-out
serviceWorkerRegistration.register({
  onUpdate: (registration) => window.dispatchEvent(new CustomEvent(SW_UPDATE_EVENT, { detail: registration })),
});
